import { types } from "./Header.actions";

export interface IHeaderStateProps {
  homeAvailable: boolean;
  homeEnabled: boolean;
  pluginAvailable: boolean;
  pluginEnabled: boolean;
  pluginMenuButtonIcon: string;
}

const defaultState: IHeaderStateProps = {
  homeAvailable: false,
  homeEnabled: false,
  pluginAvailable: false,
  pluginEnabled: false,
  pluginMenuButtonIcon: null
};

export const header = (state = defaultState, action) => {
  switch (action.type) {
    case types.SET_HOME_AVAILABLE:
      return {
        ...state,
        homeAvailable: action.value
      };
    case types.SET_HOME_ENABLED:
      return {
        ...state,
        homeEnabled: action.value
      };
    case types.SET_PLUGIN_AVAILABLE:
      return {
        ...state,
        pluginAvailable: action.value
      };
    case types.SET_PLUGIN_ENABLED:
      return {
        ...state,
        pluginEnabled: action.value
      };
    case types.SET_MOBILE_PLUGIN_MENU_BUTTON_ICON:
      return {
        ...state,
        pluginMenuButtonIcon: action.value
      };
    default:
      return state;
  }
};
